// src/components/project/ProjectCreate.jsx
import React, { useMemo } from "react";
import axios from '../../config/axiosClient';
import toast from "react-hot-toast";

import EditorApp from "./EditorApp";
import Config from "../../config/Config";
import {
  RESOLVE_LOCAL_AUTH_STATE,
  RESOLVE_LOCAL_USER_STATE,
} from "../auth/AuthActions";

export default function ProjectCreate() {
  const auth = useMemo(() => RESOLVE_LOCAL_AUTH_STATE(), []);
  const user = useMemo(() => RESOLVE_LOCAL_USER_STATE(), []);

  const initialContributors = useMemo(() => {
    if (!user?.pk) return [];
    return [{ id: user.pk, pk: user.pk, username: user.username, first_name: user.first_name, last_name: user.last_name }];
  }, [user]);

  // Create -> POST; EditorApp handles field-level/server errors
  const onSave = async (payload) => {
    try {
      const res = await axios.post(
        `${Config().baseUrl}`,
        payload,
        { headers: { Authorization: `Token ${auth?.token}` } }
      );
      return { id: res?.data?.id ?? res?.data?.pk };
    } catch (err) {
      console.error("ProjectCreate Save Error:", err);
      console.error("ProjectCreate Save Error Response:", err.response);
      console.error("ProjectCreate Save Error Status:", err.response?.status);
      console.error("ProjectCreate Save Error Data:", err.response?.data);
      throw err; // Re-throw so EditorApp can handle the UI error state
    }
  };

  const onSuccess = (id) => {
    toast.success("Project created — opening editor…");
    window.location = `/projects/${id}/edit`;
  };

  const onCancel = () => {
    window.location = "/";
  };

  return (
    <EditorApp
      draftKey="projectCreateDraft_v2"
      initialData={{ publish: false }}
      initialContributors={initialContributors}
      onSave={onSave}
      onSuccess={onSuccess}
      onCancel={onCancel}
      previewTheme="light"
      mobileBreakpointPx={768}
    />
  );
}
